import React, { ReactNode } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

interface LayoutProps{
    children: ReactNode
}

export default function Layout(props: LayoutProps) {
  return (
    <div>
      <Header />
        <div className='main'>
          {props?.children}
        </div>
      <Footer />
    </div>
  )
}
